import { TLC_CONSTANTS } from "../../../../js/lib/tlc-constants";
import { TLCEventManager } from "../../../../js/lib/events/EventManager";
import { TLCEvents } from "../../../../js/lib/events/events";
import { LS2PAC_CONSTANTS } from "../../../../js/main/constants";
import { ApplicationData } from "../ApplicationData";
import { SaveSearchControl } from "../controls/SaveSearchControl";
import { ChangeViewControl } from "../controls/changeViewControl";
import { SortingControl } from "../controls/sortingControl";
import { WorldBookDatabaseControl } from "../controls/worldBookDatabaseControl";
import { LS2PacSearchDatabaseManager } from "../managers/SearchDatabaseManager";
import { LS2PAC_Utils } from "../utils/Utils";
import { BaseView } from "./BaseView";
import { FacetsView } from "./results/FacetsView";

export class SearchPageView extends BaseView {
  constructor() {
    super({
      id: LS2PAC_CONSTANTS.Ids.SearchPage.searchPageView,
    });

    this.resources;
    this.addListeners();
  }
  addEvents() {
    var _this = this;
    if (this.hasBoundEvents === false) {
      $("#" + _this.id).on(
        "click",
        "." + LS2PAC_CONSTANTS.Ids.SearchPage.prev,
        function (event) {
          // $(event.currentTarget).addClass(LS2PAC_CONSTANTS.CssClasses.disabled);
          TLCEventManager.fireEvent(TLC_CONSTANTS.Events.onClickPrevResultPage);
          return false;
        }
      );

      $("#" + _this.id).on(
        "click",
        "." + LS2PAC_CONSTANTS.Ids.SearchPage.next,
        function (event) {
          // $(event.currentTarget).addClass(LS2PAC_CONSTANTS.CssClasses.disabled);
          TLCEventManager.fireEvent(TLC_CONSTANTS.Events.onClickNextResultPage);
          return false;
        }
      );

      $("#" + this.id).on(
        "click",
        "." + LS2PAC_CONSTANTS.CssClasses.authorLink,
        function (event) {
          LS2PacSearchDatabaseManager.setCurrentDatabaseKey(
            LS2PAC_CONSTANTS.Ids.SearchPage.Tabs.ls2pac.key
          );
          var index = _this.getElementsIndex(event);
          var author = _this.resources[index].shortAuthor;
          TLCEventManager.fireEvent(LS2PAC_CONSTANTS.Events.onSearch, {
            searchString: author,
            searchType: "author",
          });
          return false;
        }
      );

      $("#" + this.id).on(
        "click",
        "." + LS2PAC_CONSTANTS.CssClasses.fullDetails,
        function (event) {
          var index = _this.getElementsIndex(event);
          TLCEventManager.fireEvent(LS2PAC_CONSTANTS.Events.onShowFullDetails, {
            resources: _this.resources,
            index: index,
          });
          return false;
        }
      );

      $("#" + this.id).on(
        "click",
        "." + LS2PAC_CONSTANTS.CssClasses.availabilityBindClass,
        function (event) {
          var index = _this.getElementsIndex(event),
            resource = _this.resources[index];
          TLCEventManager.fireEvent(LS2PAC_CONSTANTS.Events.onShowFullDetails, {
            resources: _this.resources,
            index: index,
            viewName: LS2PAC_CONSTANTS.DetailPages.allCopies,
          });
          if (resource !== undefined) {
            TLCEventManager.fireEvent(
              LS2PAC_CONSTANTS.Events.onClickAvailabilityLink,
              {
                resource: resource,
              }
            );
          }
          return false;
        }
      );

      $("#" + this.id).on(
        "click",
        "." + LS2PAC_CONSTANTS.CssClasses.external,
        function (event) {
          var index = _this.getElementsIndex(event),
            resource = _this.resources[index];
          if (resource !== undefined && resource.downloadable === true) {
            TLCEventManager.fireEvent(
              LS2PAC_CONSTANTS.Events.onClickMoreOptionsLink,
              {
                resource: resource,
              }
            );
          }
        }
      );

      this.hasBoundEvents = true;
    }
  }
  removeEvents(){
      var _this = this;
        $("#" + _this.id).off(
          "click",
          "." + LS2PAC_CONSTANTS.Ids.SearchPage.prev);
  
        $("#" + _this.id).off(
          "click",
          "." + LS2PAC_CONSTANTS.Ids.SearchPage.next);
  
        $("#" + this.id).off(
          "click",
          "." + LS2PAC_CONSTANTS.CssClasses.authorLink,
          );
  
        $("#" + this.id).off(
          "click",
          "." + LS2PAC_CONSTANTS.CssClasses.fullDetails);
  
        $("#" + this.id).off("click",
          "." + LS2PAC_CONSTANTS.CssClasses.availabilityBindClass
          );
  
        $("#" + this.id).off(
          "click",
          "." + LS2PAC_CONSTANTS.CssClasses.external)
  
        this.hasBoundEvents = false;
      
    
  }
  getElementsIndex(event) {
    var index = parseInt($(event.currentTarget).attr("data-index"), 10);
    return isNaN(index) ? 0 : index;
  }
  setSearchTerm(value, event) {

    if(value === "null" && event.databaseKey === "reserves") {
      // do nothing, reserves has its own search term UI object
    }
    else {

    try {
      const advancedSearchOrReadingLevelSearch = typeof value === "object" ? value : JSON.parse(value);
      if (advancedSearchOrReadingLevelSearch.isReadingLevel) {
				// this.handleReadingLevel();
        this.handleReadingLevelSearchTerm(event, advancedSearchOrReadingLevelSearch);
			} else if(typeof advancedSearchOrReadingLevelSearch === "object") {
				var term = ApplicationData.language.advancedSearch + " " +  ApplicationData.language.search;
				$("#" + LS2PAC_CONSTANTS.Ids.SearchPage.searchTerm).text( term );
			} else {
        // value is not an object but still parseable as JSON, for example a number or boolean string
        $("#" + LS2PAC_CONSTANTS.Ids.SearchPage.searchTerm).text(value);
      }
    }
    catch(e){
      // value is not an object
      $("#" + LS2PAC_CONSTANTS.Ids.SearchPage.searchTerm).text(value);
    }
  }

    // try {
    //   const searchStringObject = JSON.parse(searchString);

    //   if(searchStringObject.isReadingLevel){
    //     this.handleReadingLevelSearchTerm(searchStringObject);
    //   }
    //   else {
    //     $("#" + LS2PAC_CONSTANTS.Ids.SearchPage.searchTerm).text(`${ApplicationData.language.advancedSearch} ${ApplicationData.language.search}`);
    //   }
    // }
    // catch(e){
    //   // search term is not an object
    //   // getQualifiedSearchTerm handles things like "author: J.K. Rowling" as well as normal terms "Harry Potter" 
    //   $("#" + LS2PAC_CONSTANTS.Ids.SearchPage.searchTerm).text(LS2PAC_Utils.getQualifiedSearchTerm(searchString, searchType));
    // }

    // if (LS2PAC_Utils.isSearchTermAnObject(term)) {
    //   if (term.searchString?.isReadingLevel) {
    //     this.handleReadingLevelSearchTerm(term);
    //     // this.handleReadingLevel();
    //   } else {
    //     var advancedSearchTerm =
    //       ApplicationData.language.advancedSearch +
    //       " " +
    //       ApplicationData.language.search;
    //     $("#" + LS2PAC_CONSTANTS.Ids.SearchPage.searchTerm).text(advancedSearchTerm);
    //   }
    // } else {
    //   $("#" + LS2PAC_CONSTANTS.Ids.SearchPage.searchTerm).text(term);
    // }

    this.handlePageState();
  }
  handlePageState() {}
  handleReadingLevel() {
    TLCEvents.trigger(LS2PAC_CONSTANTS.Events.onGetReadingLevelSearchFilters);
  }
  load(event) {

    $(".pagingControlsContainer").hide();
    ApplicationData.setCurrentBackEvent(LS2PAC_CONSTANTS.Events.onBackToSearch);

    // LS2PAC_Utils.getQualifiedSearchTerm(event.searchString, event.searchType);
    this.setSearchTerm(LS2PAC_Utils.getQualifiedSearchTerm(event.searchString, event.searchType), event);

    // if(event.eventName === "onFireAdvancedSearch"){
    //   this.setSearchTerm(event);
    // }
    // else {
    //   this.setSearchTerm(
    //     LS2PAC_Utils.getQualifiedSearchTerm(event.searchString, event.searchType)
    //   );
    // }
    
  }
  baseTemplateRenderCallback(event) {}
  updatePagingControls(event) {
    var prev = $("#" + this.id).find(
        "." + LS2PAC_CONSTANTS.Ids.SearchPage.prev
      ),
      next = $("#" + this.id).find("." + LS2PAC_CONSTANTS.Ids.SearchPage.next);

    $("#" + this.id)
      .find("." + LS2PAC_CONSTANTS.Ids.SearchPage.currentPage)
      .text(event.data.currentPage);
    $("#" + this.id)
      .find("." + LS2PAC_CONSTANTS.Ids.SearchPage.totalPages)
      .text(event.data.totalPages);

    // if (event.data.prevEnabled) {
    //   prev.removeClass(LS2PAC_CONSTANTS.CssClasses.disabled);
    // } else {
    //   prev.addClass(LS2PAC_CONSTANTS.CssClasses.disabled);
    // }
    prev.prop("disabled", !event.data.prevEnabled);
    next.prop("disabled", !event.data.nextEnabled);
    // if (event.data.nextEnabled) {
    //   next.removeClass(LS2PAC_CONSTANTS.CssClasses.disabled);
    // } else {
    //   next.addClass(LS2PAC_CONSTANTS.CssClasses.disabled);
    // }
  }
  disablePagingControls() {
    $("#" + this.id)
      .find("." + LS2PAC_CONSTANTS.Ids.SearchPage.currentPage)
      .text("0");
    $("#" + this.id)
      .find("." + LS2PAC_CONSTANTS.Ids.SearchPage.totalPages)
      .text("0");

    // $("#" + this.id)
    //   .find("." + LS2PAC_CONSTANTS.Ids.SearchPage.prev)
    //   .addClass(LS2PAC_CONSTANTS.CssClasses.disabled);
    // $("#" + this.id)
    //   .find("." + LS2PAC_CONSTANTS.Ids.SearchPage.next)
    //   .addClass(LS2PAC_CONSTANTS.CssClasses.disabled);
    $("#" + this.id)
      .find("." + LS2PAC_CONSTANTS.Ids.SearchPage.prev)
      .prop("disabled", true);
    $("#" + this.id)
      .find("." + LS2PAC_CONSTANTS.Ids.SearchPage.next)
      .prop("disabled", true);
  }
  addListeners() {
    var _this = this;

    this.setShowEvent(LS2PAC_CONSTANTS.Events.onSearch);
    this.setShowEvent(LS2PAC_CONSTANTS.Events.onBackToSearch);
    this.setShowEvent(LS2PAC_CONSTANTS.Events.onFireAdvancedSearch);
    this.setShowEvent(LS2PAC_CONSTANTS.Events.onFireReservesSearch);
    this.setHideEvent(LS2PAC_CONSTANTS.Events.onLogoutResponse);
    this.setHideEvent(LS2PAC_CONSTANTS.Events.onHome);
    this.setHideEvent(LS2PAC_CONSTANTS.Events.onAdvancedSearch);
    this.setHideEvent(LS2PAC_CONSTANTS.Events.onShowFullDetails);
    this.setHideEvent(LS2PAC_CONSTANTS.Events.onMyAccount);
    this.setHideEvent(LS2PAC_CONSTANTS.Events.onObrShowForm);

    const pagingGuid = TLCEventManager.addListener(
      TLC_CONSTANTS.Events.onPagingModelResponse,
      function (event) {
        _this.togglePagingControls();

        if (event.success) {
          _this.resources = event.data.resources;
          _this.searchResponse = event.data;
        }
        _this.addEvents();
        _this.updatePagingControls(event);
      }
    );
    this.removeListenerFunctions.push(() => TLCEventManager.removeListener(TLC_CONSTANTS.Events.onPagingModelResponse, pagingGuid));

    const searchGuid = TLCEventManager.addListener(
      LS2PAC_CONSTANTS.Events.onSearch,
      function (event) {
        var searchString = event.searchString;
        if (event && event.fromHistory) {
          if (
            !event.searchString &&
            event.searchParams &&
            event.searchParams.searchTerm
          ) {
            searchString = event.searchParams.searchTerm;
          }
          _this.setSearchTerm(searchString, event);
        }
      }
    );
    this.removeListenerFunctions.push(() => TLCEventManager.removeListener(LS2PAC_CONSTANTS.Events.onSearch, searchGuid));

    const backGuid = TLCEventManager.addListener(
      LS2PAC_CONSTANTS.Events.onBackToSearch,
      function (event) {
        _this.togglePagingControls();
      }
    );
    this.removeListenerFunctions.push(() => TLCEventManager.removeListener(LS2PAC_CONSTANTS.Events.onBackToSearch, backGuid));

    //TLCEventManager.addListener(LS2PAC_CONSTANTS.Events.onFireAdvancedSearch, function(event){
    //	_this.setSearchTerm("");
    //});
    const reservesGuid = TLCEventManager.addListener(
      LS2PAC_CONSTANTS.Events.onFireReservesSearch,
      function (event) {
        _this.setSearchTerm("");
      }
    );
    this.removeListenerFunctions.push(() => TLCEventManager.removeListener(LS2PAC_CONSTANTS.Events.onFireReservesSearch, reservesGuid));

    const logoutGuid = TLCEventManager.addListener(
      LS2PAC_CONSTANTS.Events.onLogoutResponse,
      function (event) {
        _this.setSearchTerm("");
        _this.disablePagingControls();
      }
    );
    this.removeListenerFunctions.push(() => TLCEventManager.removeListener(LS2PAC_CONSTANTS.Events.onLogoutResponse, logoutGuid));

  }
  togglePagingControls() {
    if (
      ApplicationData.getCurrentResultsView() != "flowView"
    ) {
      $(".pagingControlsContainer").show();
      window.scrollTo(0, 0);
    } else {
      $(".pagingControlsContainer").hide();
    }
  }
  handleReadingLevelSearchTerm(event, searchStringObject) {
    var searchString = "";
    var hasAtosFilters = false;
    var hasInterestFilter = false;
    var hasLexileFilters = false;

    const {readingLevelFilters} = event;

    if (
      readingLevelFilters.bookLevelStart ||
      readingLevelFilters.bookLevelEnd
    ) {
      hasAtosFilters = true;
    }
    if (readingLevelFilters.interestLevel) {
      hasInterestFilter = true;
    }
    if (readingLevelFilters.lexileStart || readingLevelFilters.lexileEnd) {
      hasLexileFilters = true;
    }

    const readingLevelSearchString = searchStringObject.searchTokens[0].searchString; // there is only one searchToken

    if (readingLevelSearchString) {
      searchString += readingLevelSearchString;
      if (hasAtosFilters || hasInterestFilter || hasLexileFilters) {
        searchString += ", ";
      }
    }

    if (hasLexileFilters) {
      searchString += ApplicationData.language.lexileMeasure + ": ";
      if (readingLevelFilters.lexileStart != null) {
        searchString += readingLevelFilters.lexileStart;
      }
      if (
        readingLevelFilters.lexileEnd &&
        readingLevelFilters.lexileStart != readingLevelFilters.lexileEnd
      ) {
        if (readingLevelFilters.lexileStart != null) {
          searchString += " - ";
        }
        searchString += readingLevelFilters.lexileEnd;
      }
      if (hasAtosFilters || hasInterestFilter) {
        searchString += ", ";
      }
    }
    if (hasAtosFilters) {
      searchString += ApplicationData.language.atosLevel + ": ";
      if (readingLevelFilters.bookLevelStart != null) {
        searchString += readingLevelFilters.bookLevelStart;
      }
      if (
        readingLevelFilters.bookLevelEnd &&
        readingLevelFilters.bookLevelStart != readingLevelFilters.bookLevelEnd
      ) {
        if (readingLevelFilters.bookLevelStart != null) {
          searchString += " - ";
        }
        searchString += readingLevelFilters.bookLevelEnd;
      }
      if (hasInterestFilter) {
        searchString += ", ";
      }
    }
    if (hasInterestFilter) {
      searchString +=
        ApplicationData.language.interestLevel +
        ": " +
        readingLevelFilters.interestLevel;
    }

    if (searchString == "") {
      searchString = ApplicationData.language.readingLevels;
    }

    this.setSearchTerm(searchString);
  }
  render(event) {
    $("#" + this.id).show();
    var searchTerm = LS2PAC_Utils.getQualifiedSearchTerm(event.searchString, event.searchType);
		this.setSearchTerm(searchTerm, event);

    SortingControl.init();

    ChangeViewControl.init();
    this.saveSearchControl = new SaveSearchControl(searchTerm); 
  }
  getRequiresLogin() {
    var currentConfig = LS2PacSearchDatabaseManager.getCurrentDatabaseConfig();

    if (
      currentConfig.requiresLogin &&
      !ApplicationData.locationConfiguration.isStationLocationSet()
    ) {
      return true;
    }
    return false;
  }
  canceledLoginCallback() {
    LS2PacSearchDatabaseManager.setCurrentDatabaseKey(
      LS2PAC_CONSTANTS.Ids.SearchPage.Tabs.ls2pac.key
    );
  }
  cleanup(){
    super.cleanup();
    ChangeViewControl?.cleanup();
    if(this.saveSearchControl){
      this.saveSearchControl.cleanup();
    }
    SortingControl?.cleanup();
  }
}
